module.exports = __webpack_public_path__ + "e52ff82404dfd5ccf7f3aad6383b0331.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/snd/background.mp3
// module id = 513
// module chunks = 0